import { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';

function useLiveClock() {
  const [time, setTime] = useState(new Date());
  useEffect(() => {
    const id = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  return time;
}

export function Footer() {
  const now = useLiveClock();
  return (
    <footer className="shrink-0 border-t border-border bg-white px-4 py-3 md:px-6 dark:bg-surface-elevated">
      <div className="flex flex-wrap items-center justify-between gap-3 text-[11px] text-content-subtle">
        <p className="flex items-center gap-1.5">
          <span>&copy; {new Date().getFullYear()} DB Scaffolding. All rights reserved</span>
        </p>
        <div className="flex items-center gap-3">
          <span className="cursor-pointer transition hover:text-content">Help</span>
          <span>&middot;</span>
          <span className="cursor-pointer transition hover:text-content">Privacy</span>
          <span>&middot;</span>
          <span className="cursor-pointer transition hover:text-content">Terms</span>
          <span className="text-content-muted">
            Press{' '}
            <kbd className="rounded border border-border bg-surface-muted px-1 py-0.5 text-[10px] font-mono">
              /
            </kbd>{' '}
            to search
          </span>
        </div>
        <p className="flex items-center gap-1.5 min-w-[220px] justify-end">
          <span className="inline-block h-2 w-2 shrink-0 rounded-full bg-emerald-500 shadow-[0_0_6px_rgba(16,185,129,0.6)]" />
          <span className="min-w-[130px]">All systems operational</span>
          <Clock className="h-3 w-3 shrink-0" /> {now.toLocaleTimeString()}
        </p>
      </div>
    </footer>
  );
}
